import { useState, type FC } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Card } from "../../components/ui/card";
import RadioDot from "../../components/common/RadioDot";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const MainReasonWeightLoss: FC = () => {
  const navigate = useNavigate();
  const [selectedReason, setSelectedReason] = useState<string>("");

  const handleNext = () => {
    // Save weight loss reason to session storage
    SessionStorageHelper.saveField("weight_loss_reasons", selectedReason);

    // Navigate to the next assessment page
    navigate("/glucera" + GluceraNavigationRoutes.DIETPAGE);
  };

  const reasons = [
    "To improve blood sugar / manage diabetes",
    "Doctor recommended it",
    "General health / feel better",
    "To look or feel more confident",
    "Other",
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-subhead text-muted-foreground">
            Assessment 7 of 11
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col px-6 py-2">
          <div className="mb-4 space-y-2">
            <h1 className="text-title2 font-bold text-foreground sm:text-title1">
              What's Your Main Reason For Trying To Lose Weight?
            </h1>
            <p className="text-subhead text-muted-foreground">
              The answer on the previous screen is Yes
            </p>
          </div>

          <div className="mb-4 flex-1 space-y-3 overflow-y-auto scrollbar-hide [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            {reasons.map(reason => (
              <Card
                key={reason}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selectedReason === reason
                    ? "border border-primary bg-primary/5"
                    : "border border-border hover:border-primary/50"
                }`}
                onClick={() => setSelectedReason(reason)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-title3 font-semibold text-foreground">{reason}</span>
                  <RadioDot selected={selectedReason === reason} />
                </div>
              </Card>
            ))}
          </div>

          {/* Button Container */}
          <div className="mt-auto pt-4">
            <Button
              onClick={handleNext}
              disabled={!selectedReason}
              className={gluceraAssessmentCta}
            >
              Next
            </Button>
          </div>
        </div>

        {/* Safe area padding */}
        <div className="pb-safe p-2" />
      </div>
    </div>
  );
};

export default MainReasonWeightLoss;
